module.exports = __webpack_public_path__ + "9ec06ddb2679d01181e22e1660b40e42.png";